export const handleOnChangeIsEdit = (id, isEdit, setState) => {
  setState((state) => ({
    ...state,
    [id]: isEdit,
  }))
}

export const getIsEditAll = (isEditWidget) => {
  for (const key of Object.keys(isEditWidget)) {
    if (!isEditWidget[key]) {
      return false
    }
  }
  return true
}

export const setIsEditAll = (isEdit, isEditWidget, setState) => {
  Object.keys(isEditWidget).forEach((key) => {
    setState((state) => ({ ...state, [key]: isEdit }))
  })
}

export const isSomeBoxEdit = (isEditWidget, forms) => {
  for (const key of Object.keys(isEditWidget)) {
    if (isEditWidget[key] && forms && forms[key]) {
      return true
    }
  }
  return false
}
